import { Typography } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import { MONO_FONT } from 'components/ui/tokens';
import { fadeSwap } from 'sections/rooms/rooms.motion';
import { useTourMotion } from 'sections/welcome-tour/motion';

/** FlowDialog footer caption: a mono read-back of the current choice that cross-fades when it changes. */
const FlowSummary = ({ text }: { text: string }) => {
  const { v } = useTourMotion();
  return (
    <AnimatePresence exitBeforeEnter initial={false}>
      <Typography
        key={text}
        component={motion.p}
        variants={v(fadeSwap)}
        initial="hidden"
        animate="show"
        exit="exit"
        noWrap
        sx={{ m: 0, fontFamily: MONO_FONT, fontSize: 12, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em' }}
      >
        {text}
      </Typography>
    </AnimatePresence>
  );
};

export default FlowSummary;
